import type { TestModule } from '../lib/tests';
import { Icon, type IconName } from './Icon';

/**
 * Listening, Reading and Writing each keep one colour and one mark everywhere
 * in the console — the library, results, a test day — so a teacher can tell
 * the three papers apart at a glance before reading a word.
 */
const LOOK: Record<TestModule, { label: string; icon: IconName }> = {
  LISTENING: { label: 'Listening', icon: 'headphones' },
  READING: { label: 'Reading', icon: 'book' },
  WRITING: { label: 'Writing', icon: 'pen' },
};

export function ModuleTag({
  module,
  bare = false,
  iconOnly = false,
}: {
  module: TestModule;
  bare?: boolean;
  /** Just the mark, for a row with no room for the word; the word is its title. */
  iconOnly?: boolean;
}) {
  const look = LOOK[module];
  if (iconOnly) {
    return (
      <span className={`module module--${module.toLowerCase()} module--icon`} title={look.label}>
        <Icon name={look.icon} size={13} label={look.label} />
      </span>
    );
  }
  return (
    <span className={`module module--${module.toLowerCase()}${bare ? ' module--bare' : ''}`}>
      <Icon name={look.icon} size={13} />
      {look.label}
    </span>
  );
}
